import { PAGINATION_LIMIT, TM_DEFAULT_TEAM_ID } from '@saucelabs/sl-util-config';
import { actions as notificationActions } from '@saucelabs/sl-container-notifications';

import * as api from './api';
import * as actions from './actions';
import { actions as teamsActions } from './../../ducks/teams';
import {
  actions as activityActions,
  constants as activityConstants,
  utils as activityUtils,
} from './../../ducks/activity';

export const getInitialTeamTable = () => (dispatch) => {
  dispatch(actions.getInitialTeamTableRequest());
  return dispatch(teamsActions.getTeamList())
    .then(({ data }) => {
      const teamIds = data.results.map((team) => team.id);
      const actionResult = dispatch(actions.getInitialTeamTableSuccess());

      if (!teamIds.length) {
        return actionResult;
      }

      return dispatch(activityActions.getTeamsActivity({
        teamIds,
        since: activityUtils.xDaysAgo(activityConstants.CHARTS_DATA_PERIOD),
      }));
    })
    .catch((error) => {
      dispatch(actions.getInitialTeamTableFailure(error));
      throw error;
    });
};

export const updateTableOffset = (payload) => (dispatch) => {
  const offset = (payload - 1) * PAGINATION_LIMIT;
  dispatch(actions.saveTableOffset(payload));
  dispatch(teamsActions.getTeamList({ offset }));
};

export const moveTeamUsers = (payload) => (dispatch) => {
  dispatch(actions.moveTeamUsersRequest());
  return api.moveTeamUsers(payload)
    .then(({ data }) => dispatch(actions.moveTeamUsersSuccess(data)))
    .catch((error) => {
      dispatch(notificationActions.notifyError('Couldn\'t move users to a new team'));
      dispatch(actions.moveTeamUsersFailure(error));
      throw error.response.data[0];
    });
};

// move users from [teamsId] into teamId on success remove [teamsId]
export const moveUsersBetweenTeams = (payload) => (dispatch) => {
  const movingBatch = payload.to === TM_DEFAULT_TEAM_ID ? [] : payload.from
    .map((teamId) => dispatch(moveTeamUsers({ from: teamId, to: payload.to })))
    .toArray();
  const removeTeamsBatch = payload.from
    .map((teamId) => dispatch(teamsActions.removeTeam({ id: teamId })))
    .toArray();

  const runPromisifiedMovingBatch = () => (
    Promise.all(movingBatch)
      .then(() => {
        if (movingBatch.length) {
          dispatch(notificationActions.notifySuccess('Users moved into new team'));
        }
      })
      .catch((error) => {
        dispatch(notificationActions.notifyError(error.message));
      })
  );
  const runPromisifiedRemoveTeamsBatch = () => (
    Promise.all(removeTeamsBatch)
      .then(() => {
        dispatch(notificationActions.notifySuccess(
          `${removeTeamsBatch.length > 1 ? 'Teams' : 'Team'} removed successfully`,
        ));
      })
      .catch((error) => {
        dispatch(notificationActions.notifyError(error.message));
      })
  );

  return runPromisifiedMovingBatch().then(() => runPromisifiedRemoveTeamsBatch());
};
